import React, { useEffect, useState } from "react";
import { api } from "../lib/api";
import { Search, ExternalLink } from "lucide-react";

export const SearchPartners = ({ roles, target }) => {
  const role = target?.role_title || roles?.[0]?.title || "";
  const [partners, setPartners] = useState([]);

  useEffect(() => {
    if (!role) return;
    api.get("/job-search-partners", { params: { role, location: "India" } })
      .then(r => setPartners(r.data.partners || []))
      .catch(() => {});
  }, [role]);

  if (!partners.length) return null;
  return (
    <details className="mb-4 rounded-xl border border-slate-200 bg-slate-50" data-testid="search-partners">
      <summary className="cursor-pointer list-none px-4 py-3 text-xs text-slate-600 flex items-center gap-1.5 hover:text-sky-700" data-testid="search-partners-toggle">
        <Search className="w-3.5 h-3.5 text-sky-600" /> Search "{role}" yourself on the big boards
      </summary>
      <div className="px-4 pb-4">
        <p className="text-[11px] text-slate-500">These boards don't publish an API, so we send you straight into a ready-made search on their own site.</p>
        <div className="mt-3 flex flex-wrap gap-2">
          {partners.map(p => (
            <a key={p.id} href={p.url} target="_blank" rel="noopener noreferrer" className="inline-flex items-center gap-1.5 rounded-full border border-slate-200 bg-white px-3 py-2 text-xs text-slate-700 hover:border-sky-200 hover:text-sky-700 transition-colors" data-testid={`search-partner-${p.id}`}>
              {p.name} <ExternalLink className="w-3 h-3" />
            </a>
          ))}
        </div>
      </div>
    </details>
  );
};

export default SearchPartners;
